import React from "react";
import PropTypes from "prop-types";

import Filters from "../../Filter";

const EventsListFilters = ({
  searchPlaceholder,
  searchValue,
  onSearchChange,
  catalogEventTypePlaceholder,
  catalogEventTypeValue,
  catalogEventTypeOptions,
  onCatalogEventTypeChange,
  recurrencePlaceholder,
  recurrenceValue,
  recurrenceOptions,
  onRecurrenceChange,
  crewSizePlaceholder,
  crewSizeValue,
  crewSizeOptions,
  onCrewSizeChange,
  cityPlaceholder,
  cityValue,
  cityOptions,
  onCityChange,
  startDateLabel,
  startDateValue,
  onStartDateChange,
  endDateLabel,
  endDateValue,
  onEndDateChange,
  clearDates,
  endDateBeforeStart,
}) => {
  return (
    <Filters
      searchInput={{
        placeholder: searchPlaceholder,
        name: "companyPortalEventsSearch",
        value: searchValue,
        onChange: onSearchChange,
      }}
      filters={[
        {
          type: "filter",
          name: "companyPortalCatalogEventType",
          placeholder: catalogEventTypePlaceholder,
          value: catalogEventTypeValue,
          options: catalogEventTypeOptions,
          onChange: onCatalogEventTypeChange,
        },
        {
          type: "filter",
          name: "companyPortalEventRecurrence",
          placeholder: recurrencePlaceholder,
          value: recurrenceValue,
          options: recurrenceOptions,
          onChange: onRecurrenceChange,
        },
        onCrewSizeChange && {
          type: "filter",
          name: "companyPortalEventCrewSize",
          placeholder: crewSizePlaceholder,
          value: crewSizeValue,
          options: crewSizeOptions,
          onChange: onCrewSizeChange,
        },
        onCityChange && {
          type: "filter",
          name: "companyPortalEventCity",
          placeholder: cityPlaceholder,
          value: cityValue,
          options: cityOptions,
          onChange: onCityChange,
        },
        {
          type: "date",
          name: "companyPortalEventStartDate",
          placeholder: startDateLabel,
          label: startDateLabel,
          value: startDateValue,
          onChange: onStartDateChange,
          clearfilters: clearDates,
        },
        {
          type: "date",
          name: "companyPortalEventEndDate",
          placeholder: endDateLabel,
          label: endDateLabel,
          value: endDateValue,
          onChange: onEndDateChange,
          clearfilters: clearDates,
          isInputHasErr: endDateBeforeStart,
          errMsg: "endDateBeforeStartDate",
        },
      ].filter(Boolean)}
      classNames={{
        base: "mb-0",
        search: "mb-0",
        filter: "mb-0",
        container: "d-flex flex-column",
      }}
    />
  );
};

EventsListFilters.propTypes = {
  searchPlaceholder: PropTypes.string.isRequired,
  searchValue: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  catalogEventTypePlaceholder: PropTypes.string.isRequired,
  catalogEventTypeValue: PropTypes.object,
  catalogEventTypeOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onCatalogEventTypeChange: PropTypes.func.isRequired,
  recurrencePlaceholder: PropTypes.string.isRequired,
  recurrenceValue: PropTypes.object,
  recurrenceOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onRecurrenceChange: PropTypes.func.isRequired,
  crewSizePlaceholder: PropTypes.string,
  crewSizeValue: PropTypes.object,
  crewSizeOptions: PropTypes.arrayOf(PropTypes.object),
  onCrewSizeChange: PropTypes.func,
  cityPlaceholder: PropTypes.string,
  cityValue: PropTypes.object,
  cityOptions: PropTypes.arrayOf(PropTypes.object),
  onCityChange: PropTypes.func,
  startDateLabel: PropTypes.string.isRequired,
  startDateValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onStartDateChange: PropTypes.func.isRequired,
  endDateLabel: PropTypes.string.isRequired,
  endDateValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onEndDateChange: PropTypes.func.isRequired,
  clearDates: PropTypes.bool,
  endDateBeforeStart: PropTypes.bool,
};

EventsListFilters.defaultProps = {
  catalogEventTypeValue: null,
  recurrenceValue: null,
  cityValue: null,
  clearDates: false,
  endDateBeforeStart: false,
};

export default EventsListFilters;
